import React from 'react';
import OldUIReadonlyTextInput from './OldUIReadonlyTextInput';

interface Props {
  label: string;
  tooltip?: string;
  value: { label: string } | null | undefined;
  className?: string;
}

const OldUIReadonlySelectInput: React.FC<Props> = ({ value, ...otherProps }) => {
  return <OldUIReadonlyTextInput value={value ? value.label : ''} {...otherProps} />;
};
export default OldUIReadonlySelectInput;
